import { useCallback, useState } from 'react';
import { getUserRefunds } from '../../services/invoiceService';

const useGetUserRefunds = () => {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRefunds = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getUserRefunds();
      setRefunds(data);
    } catch (err) {
      if (err.response) {
        setError(`${err.response.data.message}`);
      } else if (err.request) {
        setError('Error: No response from server');
      } else {
        setError(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { refunds, loading, error, fetchRefunds };
};

export default useGetUserRefunds;


